import { FieldConfig } from 'react-reactive-form';
import {
    ICode,
    IWorkOrder,
    Iconfig,
    IdashboardData,
    IdeficiencyCode,
    IinstallBase,
    IinstallBasePart,
    IinstallBasePartPopulated,
    IinstallBasePopulated,
    Ijob,
    IjobDefault,
    IjobHour,
    IjobPopulated,
    IjobWorkOrder,
    ImeasurementPoint,
    ImeasurementPointList,
    ImeasurementPointResult,
    Ipart,
    IpartStock,
    Iphoto,
    IpreventativeMaintenanceChecklist,
    Iproduct,
    IsimpleMeasurementPointResult,
    Isubcategory,
    IsuggestedPart,
    ItableFiltersReducer,
    Itile,
    Iuser,
    IworkOrderPart,
    WorkOrderSource
} from '../models';

import {
    partTypeEnum,
    productCommunicationMethodEnum,
    workOrderStatusEnum,
    workOrderTypesEnum,
    workOrderVendorsEnum
} from '../models-enums';

export const initialOption = { value: '', label: '' };
export const initialTableFilters: ItableFiltersReducer = {
    search: '',
    page: 0
};
export const initialTableFiltersFrontEndPaging = { search: '', page: 0 };
export const initialFacility = {
    id: '',
    name: '',
    name2: '',
    countryID: '',
    address: '',
    address2: '',
    city: '',
    state: '',
    postalCode: '',
    buildings: [],
    isDeleted: false,
    standardID: ''
};

const initialMainCategory = {
    id: '',
    name: '',
    createDate: '',
    updateDate: '',
    creatorID: '',
    updaterID: '',
    isDeleted: false
};

export const initialSubcategory: Isubcategory = {
    mainCategoryID: '',
    id: '',
    name: '',
    mainCategory: initialMainCategory,
    isDeleted: false
};

export const initialProduct: Iproduct = {
    id: '',
    name: '',
    sku: '',
    description: '',
    imagePath: '',
    subcategoryID: '',
    brandID: '',
    productTypeID: '',
    powerID: '',
    systemSizeID: '',
    isDeleted: false,
    isApproved: false,
    mergedProductID: '',
    isCompliant: true,
    hasSpares: true,
    isActive: true,
    communicationMethod: productCommunicationMethodEnum.none,
    links: [],
    isFinalProduct: true,
    productStandards: [],
    createDate: undefined,
    updateDate: undefined,
    pgc: ''
};
export const initialMeasurmentPointResult: ImeasurementPointResult = {
    id: '',
    status: 0,
    createDate: '',
    updateDate: '',
    jobID: '',
    notes: '',
    installBaseID: '',
    measurementPointListID: '',
    measurementPointAnswers: [],
    manualOverride: false,
    isDeleted: false,
    DamageCode: null
};
export const initialSimpleMeasurementPointResult: IsimpleMeasurementPointResult = {
    id: '',
    status: 0,
    createDate: '',
    updateDate: '',
    jobID: '',
    compiledNotes: '',
    measurementPointListID: '',
    measurementPointAnswers: [],
    isDeleted: false
};

export const initialInstallBase: IinstallBase = {
    id: '',
    materialID: '',
    facilityID: '',
    nickname: '',
    measurementPointListResultStatus: 0,
    workOrderResultStatus: 1,
    isDeleted: false,
    latestMeasurementPointListResultID: '',
    latestAGSMeasurementPointListResultID: '',
    latestCommissioningMeasurementPointListResultID: '',
    latestAuditMeasurementPointListResultID: '',
    latestMaintenanceMeasurementPointListResultID: '',
    latestRepairMeasurementPointListResultID: '',
    latestServicePlanMeasurementPointListResultID: '',
    latestWarrantyMeasurementPointListResultID: '',
    lastQuarterlyMaintenanceDate: '',
    lastSixMonthMaintenanceDate: '',
    latestVerificationMeasurementPointListResultID: '',
    lastYearlyMaintenanceDate: '',
    lastTwoYearMaintenanceDate: '',
    lastThreeYearMaintenanceDate: '',
    lastFiveYearMaintenanceDate: '',
    quantity: 1,
    objectPartGroup: ''
};
export const initialInstallBasePopulated: IinstallBasePopulated = {
    ...initialInstallBase,
    product: initialProduct,
    latestMeasurementPointListResult: initialMeasurmentPointResult,
    locationString: '',
    productNameString: '',
    woNumberString: '',
    workOrderID: '',
    activityDescriptionString: '',
    originalMeasurementPointListResultStatus: 0,
    isVirtual: false,
    isDecommissioned: false
};

export const initialLoc = {
    id: '',
    name: '',
    rooms: [],
    floorID: '',
    isDeleted: false
};
export const initialBuilding = {
    id: '',
    name: '',
    floors: [],
    facilityID: '',
    isDeleted: false
};
export const initialFloor = {
    id: '',
    name: '',
    locations: [],
    buildingID: '',
    isDeleted: false
};

export const initialRoom = {
    id: '',
    name: '',
    locationID: '',
    isDeleted: false
};
export const initialMeasurementPointResultAnswer = {
    measurementPointID: '',
    showInReport: true
};

export const initialInstallBasePart: IinstallBasePart = {
    id: '',
    jobID: '',
    isDeleted: false,
    installBaseID: ''
};

export const initialMeasurementPointList: ImeasurementPointList = {
    id: '',
    measurementPointTabs: [],
    mainCategoryID: '',
    standardID: '',
    type: 1,
    testProcedures: '',
    isDeleted: false
};
export const initialMeasurementPointTab = {
    id: '',
    name: 'Default Tab',
    measurementPoints: {},
    order: 0,
    isDeleted: false
};
export const initialMeasurementPoint: ImeasurementPoint = {
    id: '',
    type: 1,
    label: '',
    order: 0,
    isDeleted: false,
    isRequired: false,
    showInReport: false,
    measurementPointTabID: '',
    defaultText: ''
};

export const initialJobComment = {
    id: '',
    jobID: '',
    userID: '',
    isDeficiency: false,
    isInternal: false,
    isDeleted: false,
    text: '',
    createDate: '',
    codeID: '',
    isResolved: true
};

export const initialJob: Ijob = {
    id: '',
    facilityID: '',
    assignedUserID: '',
    jobTypeID: '80eedbac-ec22-45ef-9ac7-f2eb4be2db4c',
    startDate: '',
    endDate: '',
    status: 'New',
    isDeleted: false,
    jobNumber: '',
    jobHours: [],
    fseNotes: '',
    source: 0,
    isSAPClosed: false
};
export const initialJobPopulated: IjobPopulated = {
    ...initialJob,
    facility: initialFacility
};

export const initialJobDefaults: IjobDefault = {
    id: '',
    jobID: '',
    mpType: 3,
    mpDefaultType: 0,
    productTypeID: '',
    defaultMpAnswer: {
        showInReport: true
    }
};

export const initialJobWorkOrder: IjobWorkOrder = {
    id: '',
    jobID: '',
    workOrderID: '',
    isDeleted: false
};

export const initialDeficiencyCode: IdeficiencyCode = {
    description: '',
    name: '',
    id: '',
    isDeleted: false,
    createDate: '',
    updateDate: '',
    standardID: ''
};

export const initialCode: ICode = {
    description: '',
    name: '',
    id: '',
    isDeleted: false,
    createDate: '',
    updateDate: ''
};

export const initialPart: Ipart = {
    id: '',
    isDeleted: false,
    description: '',
    number: '',
    installationTime: 0,
    isActive: false,
    measurement: '',
    type: partTypeEnum.default
};

export const initialJobPart = {
    jobID: '',
    isDeleted: false,
    estimated: 0,
    used: 0,
    lot: '',
    id: '',
    materialID: ''
};

export const initialWorkOrderPart: IworkOrderPart = {
    materialID: '',
    workOrderID: '',
    id: '',
    estimated: 0,
    used: 0,
    isDeleted: false,
    trackingWebsite: ''
};

export const initialPartStock: IpartStock = {
    materialID: '',
    userID: '',
    id: '',
    quantity: 0,
    tLot: '',
    isDeleted: false
};

export const initialSuggestedPart: IsuggestedPart = {
    id: '',
    isDeleted: false,
    partMaterialID: '',
    productMaterialID: '',
    productQuantity: 0,
    installBaseID: '',
    InstallBaseQuantity: 0,
    adminComments: ''
};

export const initialInstallBasePartPopulated: IinstallBasePartPopulated = {
    ...initialInstallBasePart,
    part: initialPart
};

export const initialJobHour: IjobHour = {
    id: '',
    description: '',
    number: '',
    quantity: 1,
    jobID: '',
    isDeleted: false,
    date: '',
    engineerVanID: '',
    SAPEngineerID: '',
    laborRateID: ''
};

export const initialWorkOrder: IWorkOrder = {
    id: '',
    activityDescription: '',
    closingNotes: '',
    closingNotesList: null,
    activeClosingNotes: null,
    installBaseID: '',
    notes: '',
    status: workOrderStatusEnum.new,
    type: workOrderTypesEnum.repair,
    vendor: workOrderVendorsEnum.beacon,
    jobTypeID: '',
    number: '',
    isDeleted: false,
    productName: '',
    source: WorkOrderSource.MyMedGas,
    facility: initialFacility,
    sapBusinessIndicator: '',
    plannedHours: 0
};

export const initialPreventativeMaintenanceChecklist: IpreventativeMaintenanceChecklist = {
    id: '',
    name: '',
    isDeleted: false,
    preventativeMaintenancePlanID: '',
    scheduleInterval: 0,
    preventativeMaintenancePoints: []
};
export const initialToastrState = {
    toastrs: []
};

export const initialOfflineFacilityStatus = {
    locations: false,
    installBases: false,
    workOrders: false,
    photos: false,
    measurementPointResults: false
};
export const initialOfflineJobStatus = {
    simpleMeasurementPointResults: false
};

export const initialCartReducer = {
    addedIDs: [],
    itemsByID: {},
    message: ''
};

export const initialQuotePart = {
    id: '',
    quantity: 1,
    materialID: '',
    isDeleted: false
};

export const initialQuotePartCart = {
    id: '',
    isDeleted: false,
    message: '',
    quoteItems: [],
    jobID: ''
};

export const initialUser: Iuser = {
    email: '',
    securityFunctions: [],
    first: '',
    last: '',
    position: '',
    phone: '',
    facilities: [],
    hasTeamMembers: false,
    isActive: true,
    countryID: '',
    userCountries: [],
    password: '',
    username: 'robert',
    isAuthenticated: false,
    isLoggingOut: false,
    token: '',
    address: '',
    address2: '',
    city: '',
    state: '',
    zip: '',
    id: '',
    nonProductiveHours: [],
    userStandards: []
};

export const initialConfig: Iconfig = {
    isMobile: false,
    isTablet: false,
    workOrderLoadedKey: ''
};

export const initialDashboardData: IdashboardData = {
    page: 0,
    pageSize: 10,
    totalCount: 0,
    totalHours: 0,
    totalPartStatus1: 0,
    totalPartStatus2: 0,
    totalPartStatus3: 0,
    items: []
};

/* initialState */
const initialState = {
    user: initialUser,
    contactsByFacility: {},
    ajaxCallsInProgress: 0,
    isGeneratingReportPreview: false,
    syncManager: {
        isSyncRunning: false,
        downloadingJob: false,
        downloadingJobFailed: false
    },
    location: {
        pathname: ''
    },
    countries: [],
    offlineStatusOverride: false,
    cart: initialCartReducer,
    config: initialConfig,
    dashboard: {
        dashboardData: initialDashboardData
    },
    manageInventory: {
        showEditProductModal: false,
        showEditInstallModal: false,
        showSearchNewProductsModal: false,
        showAddHoursModal: false,
        showSignatureModal: false,
        showNoteModal: false,
        showModalAddFSE: false,
        showModalEditFacilityContacts: false,
        showModalVirtualSapWoParts: false,
        installBasesByID: {},
        filterConfig: {} as FieldConfig,
        commissioningDataByID: {},
        productsByID: {},
        tableFilters: initialTableFilters,
        selectedProduct: initialProduct,
        newProducts: {},
        recentProducts: [],
        productSearchFormValues: {},
        selection: [],
        enableBulkInstallBaseMode: false,
        selectedProductID: '',
        bulkInstallBaseCategory: '',
        installFormValues: {},
        showEditJobDefaultsModal: false,
        showCommissioningDataFormModal: false,
        editJobDefaultsFormValues: {},
        damageCodes: {},
        refreshInventory: '', // if this value changes, the inventory will be refreshed, part of bulk actions on manageInventory flow
        // _persist: {version: 0, rehydrated: false},
        showManageInventoryLoading: false,
        decommissionAsset: {} as { [key: string]: boolean }
    },
    manageCode: {
        totalPages: 1,
        codesByID: {},
        showEditCodeModal: false,
        tableFilters: initialTableFiltersFrontEndPaging,
        selectedCodeID: '',
        codeFormValues: {}
    },
    manageLocation: {
        visibleLocations: [],
        showEditLocationModal: false,
        tableFilters: initialTableFilters
    },
    manageJob: {
        jobsByID: {},
        jobSignaturesByID: {},
        defaultReportsByID: {},
        jobTypes: [],
        fseUsers: [],
        openedInspectionJobIDs: [],
        openedMaintenanceJobIDs: [],
        showEditJobModal: false,
        showViewJobModal: false,
        tableFilters: initialTableFilters,
        selectedJob: initialJob,
        showAddFacilityModal: false,
        showSearchFacilityModal: false,
        searchedFacilities: {},
        defaultFacilityID: '',
        jobFormValues: {},
        hourFormValues: {},
        selectedJobIDForWorkOrder: '',
        jobWorkOrdersByID: {},
        tempJobHours: {},
        selectedJobHourID: '',
        offlineStatusByID: {},
        jobFinalCheckModal: false,
        nextJobNumber: ''
    },
    manageJobComment: {
        jobCommentsByID: {},
        selectedJobComment: initialJobComment,
        showEditJobCommentModal: false,
        showJobCommentsModal: false,
        tableFilters: initialTableFilters,
        deficiencyCodesByID: {}
    },
    measurementPointLists: {
        measurementPointListsByID: {},
        measurementPointsByID: {},
        jobDefaultsByID: {}
    },
    measurementPointResults: {
        measurementPointResultsByID: {},
        selectedResult: initialMeasurmentPointResult,
        historicalResultID: '',
        historicalMPToCopy: initialMeasurmentPointResult as any
    },
    sapJobMappings: {
        sapJobMappingsByID: {}
    },
    simpleMeasurementPointResults: {
        simpleMeasurementPointResultsByID: {},
        selectedSimpleResult: initialSimpleMeasurementPointResult
    },
    showEditProfileModal: false,
    offline: {
        busy: false,
        online: true,
        retryCount: 0,
        retryScheduled: false,
        outbox: [],
        lastTransaction: 0
    },
    facilities: {},
    parts: {
        selectedInstallBasePartID: '',
        installBasePartsByID: {},
        jobPartsByID: {},
        partsByID: {},
        partStockByID: {},
        partFormValues: {},
        suggestedPartsByID: {},
        quoteCartsByID: {},
        workOrderPartsByID: {},
        virtualWorkOrderParts: []
    },
    syncStatus: {
        allProductsUpdated: 0,
        productInfoUpdated: 0,
        measurementPointsUpdated: 0,
        lastSync: 0,
        FSEUsersUpdated: 0,
        measurementPointResultsUpdated: 0,
        simpleMeasurementPointResultsUpdated: 0,
        isInitialSyncComplete: false,
        allPartsUpdated: 0,
        initialAppSyncList: [],
        downloadSpeed: undefined,
        isBackgroundProductSyncRunning: false,
        backgroundProductSyncFailed: false,
        backgroundProductSyncFinishedCount: 0,
        productProcessingProgress: null
    },
    productInfo: {
        brands: {},
        productTypes: {},
        mainCategories: {},
        powers: {},
        standards: {},
        subcategories: {},
        systemSizes: {},
        brandOptions: [],
        productTypeOptions: [],
        mainCategoryOptions: [],
        powerOptions: [],
        standardOptions: [],
        subcategoryOptions: [],
        systemSizeOptions: []
    },
    workOrder: {
        workOrdersByID: {},
        unlinkedSapWorkOrdersByID: {},
        preventativeMaintenanceChecklistsByID: {},
        showWorkOrderCloseModal: false,
        selectedWorkOrderID: '',
        historicalWorkOrderID: '',
        workOrderFormValues: {},
        showAddRepairWorkOrderModal: false,
        showConfirmSelectJobModal: false,
        isJobClosingWithSignature: false,
        isCollectingSignatures: false,
        showJobSignatureModal: false,
        isApproverSigning: false,
        partFormValues: {},
        selection: [],
        tableFilters: initialTableFilters
    },
    photos: {
        photos: {}
    },
    laborRates: [],
    initialSyncActive: false,
    offlineStatusByFacilityID: {},
    offlineStatusByJobID: {},
    _persist: {}
};

export const emptyTile: Itile = {
    icon: '',
    title: '',
    src: '',
    srcBanner: '',
    color: 'blue',
    width: 359,
    height: 136,
    url: '',
    securityFunction: '',
    description: ''
};

export const initialPhoto: Iphoto = {
    name: '',
    comments: '',
    file: '',
    fileType: 0,
    id: '',
    installBaseID: '',
    isDeleted: false,
    isInReport: false,
    jobID: '',
    lightboxUrl: '',
    thumbnailUrl: '',
    lightboxImage: '',
    thumbnailImage: '',
    createDate: '',
    updateDate: '',
    installBase: initialInstallBase,
    product: initialProduct,
    materialID: '',
    jobCommentID: '',
    measurementPointID: ''
};

export default initialState;
